import { Http, PageData, PageQuery } from '@mygpt/app/http';

interface ListParams extends PageQuery {
  // 机器人 ID
  datasetId: string;
}

export interface FAQsProperty {
  title: string;
  type: string;
  description: string;
}

export interface FAQsPropertyItem extends FAQsProperty {
  id: string;
  created_at: string;
  updated_at: string;
  robot_id: string;
}
/**
 * 获取机器人问答属性列表
 * @param params
 * @returns
 */
export const faqsPropertyListService = (params: ListParams) => {
  const { datasetId, ...rest } = params;
  const { get } = Http.use();
  return get<PageData<FAQsPropertyItem>>(`/datasets/${datasetId}/faqs/property/list`, {
    params: rest,
  });
};
